// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryTag_wrapper__2E4XD","verticalMargin":"CategoryTag_verticalMargin__2RKfP","label":"CategoryTag_label__griIR","fontS":"CategoryTag_fontS__2I58Q"};